import React, { useEffect, useState } from 'react';
import { BoxWrapper } from '../../../style';
import congratulations from "../../../images/congratulations.gif";
import { useNavigate } from 'react-router-dom';
import { getStorage } from '../../../Utils/common';
import { CheckCircle2, Home, Phone } from "lucide-react";
// import { useNavigate } from "react-router-dom";

function ThankYou() {
  const navigate = useNavigate();
  const [progressBar, setProgressBar] = useState(getStorage('percent'));

  return (
    <div>
      <BoxWrapper className="w100 gray">
        {/* <div
          className="formmainBox flex"
          style={{
            backgroundImage: `url(${congratulations})`,
            backgroundSize: 'cover',
            height: '615px',
            width: '100%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <div className="left">
            {/* Any other content you want to show */}
        {/* </div>
        </div> */}
        <div className="min-h-screenflex items-center justify-center p-4 md:p-8">

          <div className="w-full max-w-7xl bg-white rounded-3xl shadow-2xl overflow-hidden">

            <div className="grid grid-cols-1 lg:grid-cols-2 items-center">

              {/* Left */}
              <div className="p-8 sm:p-10 lg:p-14">

                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-6">
                  <CheckCircle2 className="w-10 h-10 text-green-600" />
                </div>

                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight text-[#1D3557]">
                  Thank You for
                  <span className="block text-green-600">
                    Submitting Your
                  </span>
                  Loan Application!
                </h1>

                <p className="mt-6 text-gray-600 text-base sm:text-lg leading-8">
                  We've successfully received your application.
                  Our verification team is reviewing your details.
                  You'll receive an update shortly via phone, SMS, or email.
                </p>

                <div className="mt-8 bg-green-50 border border-green-200 rounded-2xl p-5">

                  <h3 className="font-semibold text-green-700">
                    What happens next?
                  </h3>

                  <ul className="mt-4 space-y-3 text-gray-600">
                    <li>✓ Document verification</li>
                    <li>✓ Credit assessment</li>
                    <li>✓ Loan approval process</li>
                    <li>✓ Final confirmation call</li>
                  </ul>

                </div>

                <div className="mt-8 flex flex-col sm:flex-row gap-4">

                  <button
                    onClick={() => navigate("/my-dashboard")}
                    className="flex items-center justify-center gap-2 bg-[#006B54] hover:bg-[#005542] text-white font-semibold px-8 py-4 rounded-xl transition"
                  >
                    <Home size={20} />
                    Go to Dashboard
                  </button>



                </div>

              </div>

              {/* Right */}

              {/* <div className="relative bg-gradient-to-br from-sky-100 via-blue-100 to-cyan-50 flex justify-center items-center p-8 lg:p-12">

                <div className="absolute w-80 h-80 bg-blue-300 rounded-full blur-3xl opacity-30"></div>

                <img
              src="/images/thank-you-girl.png"
              alt="Loan Success"
              className="relative z-10 max-h-[550px] w-full object-contain"
            />

              </div> */}

            </div>

          </div>

        </div>
      </BoxWrapper>
    </div>
  );
}

export default ThankYou;